import PropTypes from "prop-types";
import React from "react";

const CreditCardIcon = ({nameOfCard}) => (
  <img
    aria-label={`${nameOfCard}`}
    className="w-10 h-6 pr-2"
    src={`https://karat-herokuapp-com.freetls.fastly.net/s3media/site/condensed-sign-up-page/${nameOfCard}.png`}
  />
);

CreditCardIcon.propTypes = {"nameOfCard": PropTypes.string};
CreditCardIcon.defaultProps = {"nameOfCard": ""};

export default CreditCardIcon;
